import { render, staticRenderFns } from "./ExFormat.vue?vue&type=template&id=2fdc4abf&scoped=true"
import script from "./ExFormat.vue?vue&type=script&lang=js"
export * from "./ExFormat.vue?vue&type=script&lang=js"
import style0 from "./ExFormat.vue?vue&type=style&index=0&id=2fdc4abf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc4abf",
  null
  
)

export default component.exports